import { unescape } from 'lodash-es';
import { v4 as uuid } from 'uuid';
import { HawkSearchComponents, HawkSearchGlobal } from '@models';

declare let HawkSearch: HawkSearchGlobal;

export abstract class BaseService {
    protected abstract baseUrl: string;

    public fieldMappings = {
        imageUrl: HawkSearch.config.fieldMappings?.imageUrl || 'image',
        price: HawkSearch.config.fieldMappings?.price || 'price',
        salePrice: HawkSearch.config.fieldMappings?.salePrice || 'saleprice',
        title: HawkSearch.config.fieldMappings?.title || 'itemname',
        description: HawkSearch.config.fieldMappings?.description || 'longdescription',
        type: HawkSearch.config.fieldMappings?.type || 'type',
        url: HawkSearch.config.fieldMappings?.url || 'url'
    };

    public queryStringParams = {
        disableSpellcheck: HawkSearch.config.queryStringMappings?.disableSpellcheck || 'disableSpellcheck',
        facet: HawkSearch.config.queryStringMappings?.facet || 'facet',
        page: HawkSearch.config.queryStringMappings?.page || 'page',
        pageSize: HawkSearch.config.queryStringMappings?.pageSize || 'pageSize',
        query: HawkSearch.config.queryStringMappings?.query || 'query',
        searchWithin: HawkSearch.config.queryStringMappings?.searchWithin || 'searchWithin',
        sort: HawkSearch.config.queryStringMappings?.sort || 'sort'
    };

    public searchUrl = HawkSearch.config.searchUrl ?? '/search';

    protected async httpPost<T>(relativeUrl: string, body?: any): Promise<T> {
        const url = this.baseUrl + relativeUrl;
        const headers = this.getHeaders();

        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });

        const contentType = response.headers.get('content-type');

        if (contentType?.startsWith('application/json')) {
            return response.json();
        } else {
            return undefined as unknown as T;
        }
    }

    protected stripHtml(input: string): string {
        let output = input.replace(/<[^>]+>/g, '');

        output = unescape(output);
        output = decodeURIComponent(output);

        return output;
    }

    private getHeaders(): Headers {
        const headers = new Headers();

        headers.set('Content-Type', 'application/json');
        headers.set('X-Requested-With', 'XMLHttpRequest');

        return headers;
    }

    protected getVisitorId(): string {
        const key = 'VisitorId';
        let value = localStorage.getItem(key);

        if (!value) {
            value = this.generateGuid();

            localStorage.setItem(key, value);
        }

        return value;
    }

    protected getVisitId(): string {
        const key = 'VisitId';
        let value = sessionStorage.getItem(key);

        if (!value) {
            value = this.generateGuid();

            sessionStorage.setItem(key, value);
        }

        return value;
    }

    protected generateGuid(): string {
        return uuid();
    }

    protected triggerBindEvent<T>(component: keyof HawkSearchComponents, data: T, filter?: string): void {
        let eventName = `hawksearch:bind-${component}`;

        if (filter) {
            eventName = `${eventName}:${filter}`;
        }

        this.triggerEvent(eventName, data);
    }

    protected triggerEvent<T>(name: string, data: T): void {
        const event = new CustomEvent(name, { detail: data });

        window.dispatchEvent(event);
    }
}
